<template>
  <div class="container-fluid mt-2">
    <div class="row">
      <div id="customer-form">
        <div class="row">
          <div class="col-sm-6">
            <div class="card">
              <UserEdit :type="'update'"/>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UserEdit from '@/components/views/UserEdit';

export default {
  name: "CustomerUpdate",
  components: {UserEdit}
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/views/CustomerUpdate.vue